import React, {ComponentType, useEffect, useState} from "react";
import '../assets/css/Dentobook.css';
import DetailWrapper from "../components/common/DetailWrapper";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import {useLocation, Navigate} from "react-router-dom";
import {LOCALES} from "../i18n/locales";
import PatientFormForeign from "../components/patient/PatientFormForeign";
import PatientForm, {PatientFormProps} from "../components/patient/PatientForm";
import {PatientFormData} from "../utils/patientUtils";
import {Modal} from "antd";

const PatientSelfRegister = () => {
    const { userOrganization, setUserOrganization, setLocale } = React.useContext(DentobookApplicationContext);
    const [selectedLang, setSelectedLang] = useState<string>('BG');
    const location = useLocation();

    // Show error modal if organization is missing (useEffect to avoid render-time side effect)
    React.useEffect(() => {
        if (!userOrganization?.id) {
            Modal.error({
                title: 'Error',
                content: 'Missing organization'
            });
        }
    }, [userOrganization?.id]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const lang = searchParams.get("lang");

        if (lang) {
            if (userOrganization) {
                setUserOrganization({...userOrganization, country: lang});
            }
            setSelectedLang(lang);
            setLocale(lang);
        }
    }, [location.search, userOrganization, setUserOrganization, setSelectedLang, setLocale]);

    if (!userOrganization?.id) {
        return <Navigate to="/patients"/>;
    }

    const patient: PatientFormData = {
        firstName: '',
        lastName: '',
        organizationId: userOrganization.id
    };

    const FormComponent: ComponentType<PatientFormProps> = selectedLang === LOCALES.BULGARIAN ? PatientForm : PatientFormForeign;

    return (
        <DetailWrapper>
            <FormComponent
                setEditMode={() => {}}
                mode={1}
                openModal={() => {}}
                patient={patient}
            />
        </DetailWrapper>
    );
};

export default PatientSelfRegister;